// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import BgColorsOutlinedSvg from "@fishx/icons-svg/es/asn/BgColorsOutlined";
import FishxIcon from '../components/FishxIcon';

var BgColorsOutlined = function BgColorsOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: BgColorsOutlinedSvg
  }));
};

BgColorsOutlined.displayName = 'BgColorsOutlined';
export default React.forwardRef(BgColorsOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/BgColorsOutlined.js
// module id = 2080
// module chunks = 0